import React, { Component } from "react"

class CloseSvg extends Component {

    render = () => {

        return (
            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_3057_366)">
                    <rect x="0.1875" y="3.26953" width="4.36364" height="36" transform="rotate(-45 0.1875 3.26953)" fill="white" />
                    <rect x="3.27344" y="28.7305" width="4.36364" height="36" transform="rotate(-135 3.27344 28.7305)" fill="white" />
                </g>
                <defs>
                    <clipPath id="clip0_3057_366">
                        <rect width="29" height="29" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        )

    }

}

export default CloseSvg